<template>
  <el-dialog
    title="品推主导"
    :visible.sync="dialogVisible"
    width="35%"
    class="productPromotionLeadingDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="productPromotionLeadingDialogForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="品推主导" prop="productPromotionLeading">
            <el-select v-model="formData.productPromotionLeading" placeholder="请选择">
               <el-option v-for="(item, index) in activityLevelList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '../../../newApplicationForm/service';

export default {
  data () {
    return {
      rules: {
        productPromotionLeading: [
          { required: true, message: '请选择品推主导', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {},
      activityLevelList: ['是', '否']

    };
  },
  props: {
    activityCode: {
      type: String,
      default: ''
    },
    productPromotionLeadingVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openDailg(val,ppl){
      this.dialogVisible = val;
      if(ppl===null){
        ppl='否';
      }
      this.$set(this.formData, 'productPromotionLeading', ppl);

    },
    submit () {
      this.$refs['productPromotionLeadingDialogForm'].validate((valid) => {
        if (valid) {
          this.formData.activityCode = this.activityCode; ;
           newApplicationFormApi.updateActivity(this.formData).then(res => {
            if (res.status === '200') {
              this.$message.success('修改成功');
              this.$emit('handlerSuccess');
            }
          });
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style scoped>

</style>
